// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { offlineAwareFetch } from '@/lib/offline/outbox';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

if (!supabaseUrl?.trim() || !supabaseAnonKey?.trim()) {
  const missing = [
    !supabaseUrl?.trim() && "VITE_SUPABASE_URL",
    !supabaseAnonKey?.trim() && "VITE_SUPABASE_ANON_KEY",
  ].filter(Boolean);
  throw new Error(
    `Missing Supabase env: ${missing.join(", ")}. Set them in .env or .env.local using your existing Supabase project (Dashboard → Settings → API).`
  );
}

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
  // Slice 56: job saves and photo uploads are kept on the phone when there is no signal.
  global: { fetch: offlineAwareFetch },
});